export default __webpack_public_path__ + "static/media/OpenSans-Light.3d5923f9.ttf";